import { cn } from '@utils/cn';
import type { PropsWithChildren } from 'react';

type SkeletonProps = PropsWithChildren & {
  className?: string;
};

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'animate-pulse bg-elz-neutral-4 rounded-3 h-15 w-full',
        className,
      )}
    />
  );
};
